module.exports = __webpack_public_path__ + "img/icon-out-of-stock-notify.cf13b1d7.svg";